import { InputDataDTO, ResultSetWithCalculationDetails } from "@jobrad-gmbh/bike-leasing-calculator";

type CalculatorWarning = {
  type: "uvpDeviatesTooMuchFromBikePrice" | "monthlyRateHigherThanSalary";
  belongsTo: "uvpField" | "gehaltBruttoField";
  isCritical: boolean;
  messageKey: string;
  payload?: Record<string, number>;
};

export function performPlausibiltyCheck(
  inputData: InputDataDTO,
  result: ResultSetWithCalculationDetails | null,
): CalculatorWarning[] {
  const { kaufpreis, uvp, gehaltBrutto } = inputData;

  const warnings: CalculatorWarning[] = [];

  if (uvp > kaufpreis * 1.3) {
    warnings.push({
      type: "uvpDeviatesTooMuchFromBikePrice",
      belongsTo: "uvpField",
      isCritical: false,
      messageKey: "warningMessages.uvpDeviatesTooMuchFromBikePrice",
    });
  }

  if (result) {
    const hasSubsidy = result.calculationDetails?.hasSubsidy;
    const netChargeEmployee =
      (hasSubsidy
        ? result.calculationDetails?.calculationDetailsWithSubsidy.netChargeEmployee
        : result.calculationDetails?.calculationDetailsWithoutSubsidy.netChargeEmployee) ?? 0;

    if (netChargeEmployee > gehaltBrutto)
      warnings.push({
        type: "monthlyRateHigherThanSalary",
        belongsTo: "gehaltBruttoField",
        isCritical: true,
        messageKey: "warningMessages.monthlyRateHigherThanSalary",
        payload: { 0: netChargeEmployee, 1: gehaltBrutto },
      });
  }

  return warnings;
}

export { type CalculatorWarning };
